/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_PhysicalInputs */

const en_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical`)
};

const es_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Físico`)
};

const fr_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physique`)
};

const de_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physisch`)
};

const ja_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理的`)
};

const zh_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实体`)
};

const ar_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مادي`)
};

const id_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisik`)
};

const it_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisico`)
};

const ru_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Физическое`)
};

const pt_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Físico`)
};

const ko_badge_physical = /** @type {(inputs: Badge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실물`)
};

/**
* | output |
* | --- |
* | "Physical" |
*
* @param {Badge_PhysicalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_physical = /** @type {((inputs?: Badge_PhysicalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_PhysicalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_physical(inputs)
	if (locale === "es") return es_badge_physical(inputs)
	if (locale === "fr") return fr_badge_physical(inputs)
	if (locale === "de") return de_badge_physical(inputs)
	if (locale === "ja") return ja_badge_physical(inputs)
	if (locale === "zh") return zh_badge_physical(inputs)
	if (locale === "ar") return ar_badge_physical(inputs)
	if (locale === "id") return id_badge_physical(inputs)
	if (locale === "it") return it_badge_physical(inputs)
	if (locale === "ru") return ru_badge_physical(inputs)
	if (locale === "pt") return pt_badge_physical(inputs)
	return ko_badge_physical(inputs)
});